function initNavToggle() {

	$('.btn-menu-mobile-open').on('click', function() {
			$('body').addClass('noscroll');
			$('.container-nav-menu').addClass('container-nav-menu-visible');
			$('.btn-menu-mobile-open').addClass('btn-menu-mobile-open-hidden');
			$('.btn-menu-mobile-close').addClass('btn-menu-mobile-close-visible');
		}
	);

	$('.btn-menu-mobile-close').on('click', function() {
			$('body').removeClass('noscroll');
			$('.container-nav-menu').removeClass('container-nav-menu-visible');
			$('.btn-menu-mobile-open').removeClass('btn-menu-mobile-open-hidden');
			$('.btn-menu-mobile-close').removeClass('btn-menu-mobile-close-visible');

		}
	);

	$('nav.nav-groups a:not(.nav-groups--current)').click(function() {
		$('nav.nav-groups a').removeClass('nav-groups--current');
		$(this).addClass('nav-groups--current');

		if ($('nav.nav-groups').hasClass('nav-groups--jeunes')) {
			$('nav.nav-groups').removeClass('nav-groups--jeunes');
			$('nav.nav-groups').addClass('nav-groups--scolaire');
		} else {
			$('nav.nav-groups').removeClass('nav-groups--scolaire');
			$('nav.nav-groups').addClass('nav-groups--jeunes');
		}
	});

	$('nav.nav-groups span').click(function() {
		$('nav.nav-groups a').removeClass('nav-groups--current');

		if ($(this).parent().hasClass('nav-groups--jeunes')) {
			$('nav.nav-groups').removeClass('nav-groups--jeunes');
			$('nav.nav-groups').addClass('nav-groups--scolaire');
			$("a[href='/groupe-scolaire']").addClass('nav-groups--current');
			window.location.href = "/groupe-scolaire";
		} else {
			$('nav.nav-groups').removeClass('nav-groups--scolaire');
			$('nav.nav-groups').addClass('nav-groups--jeunes');
			$("a[href='/groupe-jeunes']").addClass('nav-groups--current');
			window.location.href = "/groupe-jeunes";
		}
	});
}